import { render, staticRenderFns } from "./app-dashboard-arrow.vue?vue&type=template&id=9c4c4510&"
import script from "./app-dashboard-arrow.vue?vue&type=script&lang=js&"
export * from "./app-dashboard-arrow.vue?vue&type=script&lang=js&"
import style0 from "./app-dashboard-arrow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports